import React from "react";
import DefaultButton from "../../styles/materialButtonStyle";

import {
  StyledDialogAction, StyledDialogClose,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import MaterialDialog from "../../styles/materialDialog";

const DialogModal = ({ open, setOpen, title, content, cancelButton, approveButton }) => {

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <MaterialDialog
      open={open}
      aria-labelledby="form-dialog-title"
      className="material-dialog"
    >
      <StyledDialogWrapper>
        <StyledDialogClose onClick={handleClose}>
          <span className="icon-light-cancel"/>
        </StyledDialogClose>
        {title &&
        <StyledDialogHead id="form-dialog-title">
          {title}
        </StyledDialogHead>}
        <StyledDialogContent>
          {content}
        </StyledDialogContent>
        {(cancelButton || approveButton) &&
        <StyledDialogAction col="2">
          <DefaultButton
            onClick={handleClose}
            color="danger"
          >
            {cancelButton}
          </DefaultButton>
          <DefaultButton
            onClick={handleClose}
            color="success"
          >
            {approveButton}
          </DefaultButton>
        </StyledDialogAction>}
      </StyledDialogWrapper>
    </MaterialDialog>
  );
};

export default DialogModal;